<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs12>
						<form-localized-input v-model="item.name">
						</form-localized-input>
					</v-flex>
					<v-flex xs12>
						<form-localized-editor v-model="item.description">
						</form-localized-editor>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4>
				<v-card>
					<v-card-title primary-title>
						<h3>{{ $t("label.cover_image") }}</h3>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<app-media-library
							v-model="item.image"
						></app-media-library>
					</v-card-text>
					<v-card-text>
						<input
							type="file"
							@input="item.src = $event.target.files[0]"
							accept="application/pdf"
						/>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12> </v-flex>
		</v-layout>
		<!-- <localized-input-form v-model="item.name"></localized-input-form> -->
	</v-container>
</template>

<script>
export default {
	props: ["value"],
	data() {
		return {
			form: this.$inertia.form({
				name: null,
				avatar: null,
			}),
		};
	},
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
	methods: {
		submit() {
			this.form.post("/users");
		},
	},
};
</script>